export function shouldShowEmptyState(resource) {
    if (!resource) return false
    if (resource.loading) return false
    if (resource.loaded === false || typeof resource.loaded === 'undefined') return false
    if (resource.extension) return false

    const hasItems = (value) => {
        if (value === null || typeof value === 'undefined') return false
        if (Array.isArray(value)) return value.length > 0
        if (typeof value === 'object') {
            return Object.values(value).some((nestedValue) => hasItems(nestedValue))
        }
        return Boolean(value)
    }

    return !hasItems(resource.items)
}
